import globalState from '../state'

const addModal = (data) => {
  const id = data.id || crypto.randomUUID()
  const modal = { id, ...data }
  globalState.modals = [...globalState.modals, modal]
  return modal
}

const removeModal = (_id) => {
  globalState.modals = globalState.modals.filter(({ id }) => id !== _id)
}

export default () => ({ addModal, removeModal })
